import * as React from 'react';
import {
  CarouselBreakpoints,
  BenefitsItem as TBenefitsItem,
} from '~/common/types/types';
import { Carousel } from '~/components/common/common';
import { BenefitsItem } from '../components';
import * as styles from './benefits-list.module.scss';
import { CarouselEffect } from '~/common/enums/enums';

const BREAKPOINTS: CarouselBreakpoints = {
  0: {
    isLooped: true,
    slidesPerView: 1,
    spaceBetween: '30',
    centeredSlides: true,
    wrapperClassName: styles.carouselWrapper,
  },
  1080: {
    isLooped: true,
    slidesPerView: 2,
    centeredSlides: true,
    effect: CarouselEffect.COVERFLOW,
    wrapperClassName: styles.carouselWrapper,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 420,
      modifier: 1,
      slideShadows: false,
    },
  },
};

type Props = {
  items: TBenefitsItem[];
};

const BenefitsList: React.FC<Props> = ({ items }) => (
  <Carousel breakpoints={BREAKPOINTS} className={styles.carousel} hasNavigation>
    {items.map((item) => (
      <BenefitsItem key={item.title} item={item} />
    ))}
  </Carousel>
);

export { BenefitsList };
